module.exports = __webpack_public_path__ + "static/OCSP-d4f4d17fb509db78ee1f1cc4120c8392.png";